import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAllModelTypesList = async (): Promise<IGetModelTypesList []> => {
  return axiosDefaultApi.get(`api/ModelTypes/GetModelTypes`);
};

type QueryFnType = typeof getAllModelTypesList;

type UseGetAllModelTypesListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllModelTypesList = ({ config }: UseGetAllModelTypesListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllModelTypesList'],
    queryFn: () => getAllModelTypesList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των περιοχών.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};